import { IS_EXISTING_CUSTOMER } from '@constants/queryParams';

const getIsExistingCustomerFromUrl = () => {
  return (
    new URLSearchParams(window.location.search).get(IS_EXISTING_CUSTOMER) ===
    '1'
  );
};

export { getIsExistingCustomerFromUrl };
